import React, { useState, useEffect } from 'react'
import { getAllJobs } from '../../utils/jobStorage'
import { getLastLogin } from '../../utils/auth'
import JobManager from './JobManager'
import AdminStats from './AdminStats'
import AdminSettings from './AdminSettings'

const AdminDashboard = ({ onLogout }) => {
  const [activeTab, setActiveTab] = useState('jobs')
  const [stats, setStats] = useState({
    totalJobs: 0,
    activeJobs: 0,
    inactiveJobs: 0
  })
  const [lastLogin, setLastLogin] = useState(null)

  useEffect(() => {
    const login = getLastLogin()
    if (login) setLastLogin(new Date(login))
  }, [])

  useEffect(() => {
    fetchStats()
  }, [])

  const fetchStats = async () => {
    try {
      const jobs = getAllJobs()
      setStats({
        totalJobs: jobs.length,
        activeJobs: jobs.filter(job => job.active).length,
        inactiveJobs: jobs.filter(job => !job.active).length
      })
    } catch {
      // stats remain at default zero values
    }
  }

  const tabs = [
    { id: 'jobs', label: 'Job Management', icon: 'fas fa-briefcase' },
    { id: 'stats', label: 'Statistics', icon: 'fas fa-chart-bar' },
    { id: 'settings', label: 'Settings', icon: 'fas fa-cog' }
  ]

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div className="admin-header-content">
          <div className="admin-logo">
            <i className="fas fa-house-chimney"></i>
            <span>Talent</span><strong>House</strong>
            <span className="admin-badge">Admin</span>
          </div>
          <div className="admin-header-right">
            {lastLogin && (
              <span className="last-login">
                <i className="fas fa-clock"></i>
                Last login: {lastLogin.toLocaleDateString()} {lastLogin.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
            <button className="btn btn-secondary" onClick={onLogout}>
              <i className="fas fa-sign-out-alt"></i>
              Logout
            </button>
          </div>
        </div>
      </div>

      <div className="admin-content">
        <div className="admin-sidebar">
          <nav className="admin-nav">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`admin-nav-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <i className={tab.icon}></i>
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="admin-main">
          {activeTab === 'jobs' && <JobManager onJobChange={fetchStats} />}
          {activeTab === 'stats' && <AdminStats stats={stats} />}
          {activeTab === 'settings' && (
            <AdminSettings />
          )}
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
